const IDeliveryChargeAreaActionTypes = {
    setSearchValue: 'setSearchValue',
    setEupMyeonDongBoundaryVisibleList: 'setEupMyeonDongBoundaryVisibleList',
    setEupMyeonDongBoundaryInfo: 'setEupMyeonDongBoundaryInfo',
    setIsCreateAreaMode: 'setIsCreateAreaMode',
    setCurrentPolygonCoordinateList: 'setCurrentPolygonCoordinateList',
    setCurrentPolygonNeedResetList: 'setCurrentPolygonNeedResetList',
    getRegisteredAreaList: 'getRegisteredAreaList',
    setCheckedListAreaInfo: 'setCheckedListAreaInfo',
    postRegisteredAreaList: 'postRegisteredAreaList',
    editClickedAreaName: 'editClickedAreaName',
    deleteClickedArea: 'deleteClickedArea',
    setSelectedArea: 'setSelectedArea',
    resetStore: 'resetStore',
};
const IDeliveryChargeAreaMutations = {
    SET_SEARCH_VALUE: 'SET_SEARCH_VALUE',
    SET_EUP_MYEON_DONG_BOUNDARY_VISIBLE_LIST: 'SET_EUP_MYEON_DONG_BOUNDARY_VISIBLE_LIST',
    SET_EUP_MYEON_DONG_BOUNDARY_CURRENT_INFO: 'SET_EUP_MYEON_DONG_BOUNDARY_CURRENT_INFO',
    SET_IS_CREATE_AREA_MODE: 'SET_IS_CREATE_AREA_MODE',
    SET_CURRENT_POLYGON_COORDINATE_LIST: 'SET_CURRENT_POLYGON_COORDINATE_LIST',
    SET_CURRENT_POLYGON_NEED_RESET_LIST: 'SET_CURRENT_POLYGON_NEED_RESET_LIST',
    SET_REGISTERED_AREA_LIST: 'SET_REGISTERED_AREA_LIST',
    SET_CHECKED_AREA_LIST: 'SET_CHECKED_AREA_LIST',
    SET_SELECTED_AREA: 'SET_SELECTED_AREA',
    RESET_STORE: 'RESET_STORE',
};
export { IDeliveryChargeAreaActionTypes, IDeliveryChargeAreaMutations, };
